import React from 'react';
import { GrantsSearch } from './GrantSearch';
import { OrganizationForm } from './OrganizationForm';
import { ProfileForm } from './ProfileForm';
import { ReviewGrants } from './ReviewGrants';
export const Steps = ({ step }) => {
    return (React.createElement(React.Fragment, null,
        step === 0 && React.createElement(ProfileForm, null),
        step === 1 && React.createElement(OrganizationForm, null),
        step === 2 && React.createElement(GrantsSearch, null),
        step === 3 && React.createElement(ReviewGrants, null)));
};
